import React from "react";
import {RangeSlider} from "@blueprintjs/core";

const RangeSliderInput = (props) => {
    const {
        min,
        max,
        onChange,
        onRelease,
        labelStepSize,
        value,
        style = {},
        label = ""
    } = props;

    const customStyles = {

    };

    return (
        <div style={{
            ...style
        }}>
            {!!label && <div style={{
                color: "black",
                fontWeight: "bold",
                fontSize: 12,
                marginBottom: 5
            }}>{label}</div>}
            <RangeSlider
                styles={customStyles}
                onChange={onChange}
                onRelease={onRelease}
                value={value}
                labelStepSize={labelStepSize}
                min={min}
                max={max}
            />
        </div>
    );
};

export default RangeSliderInput;